import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=53c12f3a&scoped=true"
import script from "./sort.vue?vue&type=script&lang=js"
export * from "./sort.vue?vue&type=script&lang=js"
import style0 from "./sort.vue?vue&type=style&index=0&id=53c12f3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c12f3a",
  null
  
)

export default component.exports